export const VENDOR_USER_TYPE = "Vendor";
export const SUPERVISOR_USER_TYPE = "Supervisor";
export const SUPPLIER_USER_TYPE = "Supplier";
export const STAFF_USER_TYPE = "Staff";
export const SYSTEM_USER_TYPE = "System";
